import { OverlayTrigger, Row, Tooltip } from 'react-bootstrap'
import { ArrowRightCircleFill } from 'react-bootstrap-icons'
import ReactQuill from 'react-quill'
import 'react-quill/dist/quill.snow.css'

import {
  ContainerComponent,
  ContentComponent,
  FooterComponent,
  NextButton,
} from '../../styles'

export function InformacoesAdicionais({
  isVisible,
  onNext,
  product,
  setProduct,
}) {
  if (!isVisible) {
    return null
  }

  return (
    <ContainerComponent>
      <div>
        <ContentComponent>
          <h4>Informações Adicionais</h4>

          <Row
            style={{
              height: '70vh',
            }}
          >
            <ReactQuill
              name="DESC_ITEM"
              theme="snow"
              value={product.DESC_ITEM}
              style={{
                width: '100%',
                height: 250,
              }}
              onChange={(value) =>
                setProduct((prevState) => ({
                  ...prevState,
                  adicionais: {
                    ...prevState.adicionais,
                    DESC_ITEM: value,
                  },
                }))
              }
            />

            <FooterComponent>
              <OverlayTrigger overlay={<Tooltip>Avançar</Tooltip>}>
                <NextButton onClick={onNext}>
                  <ArrowRightCircleFill
                    size={15}
                    color="white"
                  />
                </NextButton>
              </OverlayTrigger>
            </FooterComponent>
          </Row>
        </ContentComponent>
      </div>
    </ContainerComponent>
  )
}
